//平台方管理
export default [
    {
        path: 'fence',
        name: 'fence',
        meta: {
            title: '电子围栏',
            icon: 'fence'
        },
        hidden: false,
        component: () => import("@/views/operate/fence/index.vue"),
        children: [{
            alias: '',
            path: 'fenceManage',
            name: 'fenceManage',
            meta: {
                title: '围栏管理',
                icon: 'fenceManage'
            },
            hidden: false,
            component: () => import("@/views/operate/fence/fenceManage.vue"),
        },
        {
            path: 'fenceTrajectory',
            name: 'fenceTrajectory',
            meta: {
                title: '骑行轨迹',
                icon: 'fenceTrajectory'
            },
            hidden: true,
            component: () => import("@/views/operate/fence/fenceTrajectory.vue"),
        }]
    }

]